import { PartProperty } from "../reducers/models/parts";

const PREFIXES: { [exponent: string]: string } = {
  "24": "Y",
  "21": "Z",
  "18": "E",
  "15": "P",
  "12": "T",
  "9": "G",
  "6": "M",
  "3": "k",
  "0": "",
  "-3": "m",
  "-6": "µ",
  "-9": "n",
  "-12": "p",
  "-15": "f",
  "-18": "a",
  "-21": "z",
  "-24": "y",
};

export function formatSI(quantity: number): string {
  if (quantity === 0) {
    return "0";
  }
  let sig = Math.abs(quantity); // significand
  let exponent = 0;
  while (sig >= 1000 && exponent < 24) {
    sig /= 1000;
    exponent += 3;
  }
  while (sig < 1 && exponent > -24) {
    sig *= 1000;
    exponent -= 3;
  }

  const signPrefix = quantity < 0 ? "-" : "";
  if (sig > 1000) {
    // exponent == 24
    // significand can be arbitrarily long
    return signPrefix + sig.toFixed(0) + PREFIXES[exponent];
  }
  return `${signPrefix}${parseFloat(sig.toPrecision(6))}${PREFIXES[exponent]}`;
}

export function ElementKeyValue({
  keyName,
  value,
}: {
  keyName: string;
  value: string;
}) {
  return (
    <div style={{ wordWrap: "break-word" }}>
      <span style={{ fontWeight: 500 }}>{keyName}:</span>
      {` ${value}`}
    </div>
  );
}

function formatPercentage(quantity: number) {
  return `${quantity}%`;
}

export function formatSIWithUnit(quantity: number, unit: string) {
  if (unit == "%") {
    return formatPercentage(quantity);
  }
  return `${formatSI(quantity)} ${unit}`.trim();
}

export function formatSIWithUnitShort(quantity: number, unit: string) {
  if (unit == "%") {
    return formatPercentage(quantity);
  }
  return `${formatSI(quantity)}${unit}`.trim();
}

export function displayProperty(property: PartProperty) {
  if (property.value) {
    return property.value;
  }
  const quantity = property.quantity || 0;
  if (property.parameter.short_unit) {
    return formatSIWithUnitShort(quantity, property.parameter.short_unit);
  }
  return formatSIWithUnit(quantity, property.parameter.unit || "");
}

export function ElementPropertyKeyValue({
  property,
}: {
  property: PartProperty;
}) {
  return (
    <ElementKeyValue
      keyName={property.parameter.name}
      value={displayProperty(property)}
    />
  );
}

export function sortProperties(a: PartProperty, b: PartProperty) {
  const aToken = a.value !== null ? a.value : a.quantity;
  const bToken = b.value !== null ? b.value : b.quantity;
  if (aToken !== null && bToken !== null) {
    if (aToken < bToken) {
      return -1;
    }
    if (aToken > bToken) {
      return 1;
    }
  }
  return 0;
}
